import Image from 'next/image'

import { GeneralNoticeState } from 'components/NoticeState'

import type { FC } from 'react'

interface StateErrorProps {
  onClick?: () => void
}

const StateError: FC<StateErrorProps> = ({ onClick }) => {
  return (
    <GeneralNoticeState
      containerClassNames="flex flex-col items-center justify-center"
      icon={
        <Image
          src="/images/errors/img-error-fixing.png"
          alt=""
          width="84"
          height="84"
          className="select-none pointer-events-none"
        />
      }
      titleVariant="heading-sm"
      descriptionVariant="body"
      titleClassNames="!mt-3 select-none"
      descriptionClassNames="!mt-1 text-center select-none"
      showButton={!!onClick}
      buttonColor="blue"
      onButtonClick={onClick}
    />
  )
}
export default StateError
